import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "stock/product"

class service {

    findSource(productId = 0, stockPlaceProductInsideId = 0, sourceOrderBy = "", stockOnlyNewProduced = false, typeAutomatically = "N", expeditionId = 0, customerId = 0) {

        let params = new URLSearchParams()

        params.set("typeAutomatically", typeAutomatically)
        params.set("sorted", sourceOrderBy)

        if (expeditionId > 0)
            params.set("expeditionId", "" + expeditionId)

        if (stockOnlyNewProduced)
            params.set("stockOnlyNewProduced", "" + stockOnlyNewProduced)

        if (productId > 0)
            params.set("productId", "" + productId)

        if (stockPlaceProductInsideId > 0)
            params.set("stockPlaceProductInsideId", "" + stockPlaceProductInsideId)

        if (customerId > 0)
            params.set("customerId", "" + customerId)

        return http.list(path + "/findSource", params);
    }

    getResume(productId, stockPlaceProductInsideId = 0, resumeOnly = true) {

        let params = new URLSearchParams()
        let method = "extractByProduct"

        params.set("productId", "" + productId)

        if (stockPlaceProductInsideId > 0) {
            method = "extractByProductAndStockPlace"
            params.set("stockPlaceProductInsideId", "" + stockPlaceProductInsideId)
        }

        if (resumeOnly) {
            params.set("resumeOnly", "true")
        }

        return http.list(path + "/" + method, params);
    }


}

export default new service();


